import {
  FlashMessage,
  FullScreenModalController,
  HostSkippedQuestion,
  Reconnecting,
  ScoreTooltip,
  TakingTooLong,
} from '../features';
import Footer from '../features/footer/Footer';
import NavBar from '../features/navbar/Navbar';

const Layout: React.FC = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <div
        className="bg-fixed bg-repeat flex-grow pb-4 w-full sm:pb-6 lg:pb-8"
        style={{
          backgroundImage:
            "url('./assets/bg.svg'), linear-gradient(180deg, #431975 0%, #331359 100%)",
        }}
      >
        <HostSkippedQuestion />
        <TakingTooLong />
        <NavBar />
        <Reconnecting />
        <ScoreTooltip />
        <FlashMessage />
        <FullScreenModalController />
        <main>{children}</main>
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
